import React from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import deleteImg from "../../assets/images/delete.svg";
import editImg from "../../assets/images/edit.svg";
import {
    removeTransaction,
    setActiveEditingTransaction,
    setEdit,
    setShowModal,
} from "../../features/transaction/transactionSlice";
import numberWithCommas from "../../utils/NumberWithCommas";

const Transaction = ({ transaction }) => {
    const dispatch = useDispatch();
    const { name, type, amount, id } = transaction || {};
    const location = useLocation();

    const handleEdit = () => {
        if (location.pathname === "/all-transactions") {
            dispatch(setShowModal(true));
        }

        dispatch(setEdit(true));
        dispatch(setActiveEditingTransaction(transaction));
    };

    const handleDelete = (id) => {
        dispatch(removeTransaction(id));
    };

    return (
        <li className={`transaction ${type}`}>
            <p>{name}</p>
            <div className="right">
                <p>৳ {numberWithCommas(amount)}</p>
                <button onClick={handleEdit} className="link">
                    <img alt="edit" className="icon" src={editImg} />
                </button>
                <button className="link" onClick={() => handleDelete(id)}>
                    <img alt="delete" className="icon" src={deleteImg} />
                </button>
            </div>
        </li>
    );
};

export default Transaction;
